import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ListUsers from "../components/users/list-users/list-users";

import { PracticesCqsProvider } from "../contexts/practices-cqs-context";
import { PracticesLoansProvider } from "../contexts/practices-loans-context";
import { UserProvider } from "../contexts/user-context";
import { ServiceProvider } from "../contexts/service-context";
import UserInfoPage from "../components/users/user-info/user-info";
import { UserFeeProvider } from "../contexts/user-fee-context";
import { useAuthenticator } from "@aws-amplify/ui-react";

const Users = ({ match }) => {
  const { user } = useAuthenticator();
  const role =
    user &&
    user.signInUserSession &&
    user.signInUserSession.accessToken &&
    user.signInUserSession.accessToken.payload &&
    user.signInUserSession.accessToken.payload["cognito:groups"] &&
    user.signInUserSession.accessToken.payload["cognito:groups"].length
      ? user.signInUserSession.accessToken.payload["cognito:groups"][0]
      : "CLIENTE";

  const isAdmin = role === "ADMIN";
  return (
    <div className="users-page">
      <UserProvider>
        <ServiceProvider>
          <PracticesCqsProvider>
            <PracticesLoansProvider>
              <Switch>
                <Route exact path={match.path} component={ListUsers} />
                <UserFeeProvider>
                  <Route
                    exact
                    path={`${match.path}/info/:id`}
                    render={(props) =>
                      isAdmin ? (
                        <UserInfoPage {...props} isAdmin />
                      ) : (
                        <Redirect to="/home" />
                      )
                    }
                  />
                </UserFeeProvider>
              </Switch>
            </PracticesLoansProvider>
          </PracticesCqsProvider>
        </ServiceProvider>
      </UserProvider>
    </div>
  );
};

export default Users;
